import React, { useState } from 'react';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

const Filter = (props) => {
    const [select, setSelect] = useState('all');

    const onChangeRadioBtn = (e, value) => {
        setSelect(value);
        props.changeFilter(value);
    };

    return (
        <div className='paper-block margin-10'>
            <span className='name-block absolute small-name'>Filter areas</span>
            <RadioButtonGroup onChange={onChangeRadioBtn} name="filter-areas" valueSelected={select}>
                <RadioButton
                    value="all"
                    label="All"
                />
                <RadioButton
                    value="noPorts"
                    label="No ports"
                />
                <RadioButton
                    value="noMainPorts"
                    label="No main ports"
                />
                <RadioButton
                    value="mainRegions"
                    label="Main regions"
                />
            </RadioButtonGroup>
        </div>
    );
};

export default Filter;



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/FilterAreas/Filter.jsx